import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLanguage } from "../../../../../../context/LanguageProvider";
import AppURL from "../../../../../../constants/AppURL";
import { formatMoney_2 } from "../../../../../../helpers/DateFormat";
import { RootState } from "../../../../../../store/store";

const PrintSingleVoucherView = ({ singleLedList }: {singleLedList: any}) => {
  const { language } = useLanguage();
  const { SOFTWARE_ORG, SET_FULL_SOFT_DATA } = useSelector((state: RootState) => state.software);
  const org_details = SOFTWARE_ORG?.org;  

  const [totalAmt, setOnTotalAmt] = useState({
    totalCrAmt: 0,
    totalDrAmt: 0,
  });

  useEffect(() => {
    const totalCrAmount = singleLedList?.data
      ? singleLedList?.data?.reduce(
          (total: number, ledger: any) => total + (ledger?.creditamt || 0),
          0
        )
      : 0;
    const totalDrAmount = singleLedList?.data
      ? singleLedList?.data?.reduce(
          (total: number, ledger: any) => total + (ledger?.debitamt || 0),
          0
        )
      : 0;
    setOnTotalAmt({ totalCrAmt: totalCrAmount, totalDrAmt: totalDrAmount });
  }, [singleLedList]);

const groupedData = singleLedList?.data?.reduce((acc: any, item: any) => {
  if (!item?.actual_glid) return acc;

  // Initialize GL if not exists
  if (!acc[item.actual_glid]) {
    acc[item.actual_glid] = {
      gl_name: item.gl_name || "Unknown",
      actual_glid: item?.actual_glid || "Unknown",
      gl_name_nep: item.gl_name_nep || "अज्ञात",
      sub_ledgers: {},
    };
  }

  // Initialize SubLedger if not exists
  if (!acc[item.actual_glid].sub_ledgers[item.sub_ledg_name]) {
    acc[item.actual_glid].sub_ledgers[item.sub_ledg_name] = {
      sub_ledg_name: item.sub_ledg_name || "Unknown",
      sub_ledg_name_nep: item.sub_ledg_name_nep || "अज्ञात",
      sglsn: item?.sglsn || "",
      particulars: [],  // Array to store unique particulars
      debitamt: 0,
      creditamt: 0,
    };
  }

  const subLedger = acc[item.actual_glid].sub_ledgers[item.sub_ledg_name];
  subLedger.debitamt += item?.debitamt || 0;
  subLedger.creditamt += item?.creditamt || 0;

  // Find if particular already exists
  const particularId = item?.particularid || "unknown";
  const existingParticular = subLedger.particulars.find(
    (p: any) => p.particularid === particularId
  );

  if (existingParticular) {
    // Sum amounts if particular exists
    existingParticular.debitamt += item.debitamt || 0;
    existingParticular.creditamt += item.creditamt || 0;
  } else {
    // Add new particular if doesn't exist
    subLedger.particulars.push({
      particular_name: item.particular_name || "Unknown",
      particunamenep: item.particunamenep || "अज्ञात",
      particularid: particularId,
      debitamt: item.debitamt || 0,
      creditamt: item.creditamt || 0,
    });
  }

  return acc;
}, {}) || {};

  return (
    <Fragment>
      <style>
        {`@media print {
            @page {
            size: A4 portrait;
            page-break-before: always;
            margin: 0.3in; 
            border: 1px solid oklch(70.4% 0.04 256.788);
         }
        }`}
      </style>
      <div className="bg-white h-screen">
         <div className="relative border border-gray-300 p-0.5">
                <table className="w-full text-sm text-left rtl:text-right text-black">
                    <tbody>
                        <tr>
                            <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                                {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {org_details?.org_reg}
                            </td>
                            <td className="w-[25%]">
                            </td>
                            <td className="w-[25%]">
                            </td>
                            <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {org_details?.org_phone}
                            </td>
                        </tr>
                        <tr >
                            <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                                <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                            </td>
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                            </td>
                            <td className="w-[25%]">
                            </td>
                        </tr>
                        <tr >
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                            </td>
                            <td align='right' className={`w-[25%] text-[11px] text-black font-light ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Date: " : "मिति: "} {SET_FULL_SOFT_DATA?.today_np}
                            </td>
                        </tr>
                        <tr >
                            <td align='center' colSpan={2} className={`w-[25%] underline font-bold text-black text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Single Voucher Report" : "एकल भौचर रिपोर्ट"}
                            </td>
                            <td className="w-[25%]">
                            </td>
                        </tr>
                        <tr>
                            <td align='center' colSpan={2} className={`w-[25%] text-black font-normal italic text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                {language === "Eng" ? "Transaction Date: " : "कारोबार मिति: "}
                                {singleLedList?.date }
                            </td>
                            <td align='right' className="w-[25%] text-[11px]">
                                {language === "Eng" ? "Voucher No.:........" : "भौचर नम्बर:........."}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        <div className="relative h-[68%]">
          <table className="w-full text-sm text-left rtl:text-right text-black">
            <thead className="text-[12px] text-black capitalize bg-slate-100">
              <tr className="bg-slate-100">
                <th
                  scope="col"
                  className={`px-1 py-0.5 border-y-[1px] border-slate-400 font-bold w-10 text-center ${
                    language==="Eng" ? "font-public-sans" : "font-nepali"
                  }`}
                >
                  {language==="Eng" ? "S.N." : "क्र.सं."}
                </th>
                <th
                  scope="col"
                  className={`px-1 py-0.5 border-[1px] !border-slate-400 font-bold text-center ${
                    language==="Eng" ? "font-public-sans" : "font-nepali"
                  }`}
                >
                  {language==="Eng" ? "Particular Name" : "बिबरण नाम"}
                </th>
                <th
                  scope="col"
                  className={`px-1 py-0.5 border-y-[1px] border-slate-400 font-bold text-right ${
                    language==="Eng" ? "font-public-sans" : "font-nepali"
                  }`}
                >
                  {language==="Eng" ? "Debit Amount" : "डेबिट रकम"}
                </th>
                <th
                  scope="col"
                  className={`px-1 py-0.5 border-y-[1px] border-slate-400 font-bold text-right ${
                    language==="Eng" ? "font-public-sans" : "font-nepali"
                  }`}
                >
                  {language==="Eng" ? "Credit Amount" : "क्रेडिट रकम"}
                </th>
              </tr>
            </thead>
            <tbody className="text-slate-800 text-[12px]">
              {Object.keys(groupedData).map((glKey) => {
                const group = groupedData[glKey];
                return (
                  <React.Fragment key={glKey}>
                    <tr className={`font-bold ${
                      language==="Eng" ? "font-public-sans" : "font-nepali"
                    }`}>
                      <td colSpan={4} className={`border-y border-slate-400 p-0.5 ${
                      language==="Eng" ? "font-public-sans" : "font-nepali"
                    }`}>
                        {language==="Eng" ? `${group.actual_glid}. ${group.gl_name}` : group.gl_name_nep}
                      </td>
                    </tr>

                    {Object.keys(group.sub_ledgers).map((subKey, subIndex) => {
                      const sub = group.sub_ledgers[subKey];
                      return (
                        <React.Fragment key={subKey}>
                          <tr className={`${language==="Eng" ? "font-public-sans" : "font-nepali"}`}>
                            <td align="center" className={`border-y border-slate-400 p-0.5 text-center ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>
                              {subIndex + 1}.
                            </td>
                            <td className={`border border-slate-400 p-0.5 font-semibold ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>
                              {sub?.sglsn}. {language==="Eng"
                                ? sub.sub_ledg_name
                                : sub.sub_ledg_name_nep}
                            </td>
                            <td className="border border-slate-400 p-0.5 text-right"></td>
                            <td className="border-y border-slate-400 p-0.5 text-right" />
                          </tr>

                          {sub.particulars.map((particular: any, partIndex: number) => (
                            <tr key={partIndex} className={`${language==="Eng" ? "font-public-sans" : "font-nepali"}`}>
                              <td align="center" className="border-y border-slate-400 p-0.5">{subIndex + 1}.{partIndex+1}.</td>
                              <td className={`border border-slate-400 p-0.5 pl-4 ${language==="Eng" ? "font-public-sans" : "font-nepali"}`}>
                              {particular?.particularid}. {language==="Eng"
                                  ? particular.particular_name
                                  : particular.particunamenep}
                              </td>
                              <td className={`border border-slate-400 p-0.5 text-right ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>
                                {formatMoney_2(particular.debitamt || 0)}
                              </td>
                              <td className={`${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    } border border-slate-400 p-0.5 text-right`}>
                                {formatMoney_2(particular.creditamt || 0)}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                );
              })}
              {/* Total Amount Row */}
              <tr
                className={`font-public-sans text-black bg-slate-100 ${
                  language==="Eng" ? "font-public-sans" : "font-nepali"
                }`}
              >
                <td
                  colSpan={2}
                  className={`px-2 py-0.5 font-bold border-y !border-slate-400 text-left ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                >
                  {language==="Eng" ? "Total Amount" : "कुल रकम"}
                </td>
                <td className={`px-2 py-0.5 border border-slate-400 font-bold text-right ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>
                  {formatMoney_2(totalAmt.totalDrAmt)}
                </td>
                <td className={`px-2 py-0.5 border border-slate-400 font-bold text-right ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>
                  {formatMoney_2(totalAmt.totalCrAmt)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          className={`px-2 py-0.5 h-28 text-sm font-normal border-t border-slate-500 capitalize ${
            language==="Eng" ? "font-public-sans" : "font-nepali"
          }`}
        >
          <span
            className={`${language==="Eng" ? "font-public-sans" : "font-nepali"}`}
          >
            {language==="Eng" ? "Remarks" : "बिवरण"}
          </span>{" "}
          : {singleLedList?.data_remarks}
        </div>
        <div className="absolute bottom-0 w-full p-4">
          <div className="flex justify-between items-center">
            <div className="flex-grow"></div>
            <div
              className={`flex justify-between w-full items-center space-x-8 ${
                language==="Eng" ? "font-public-sans" : "font-nepali"
              }`}
            >
              {/* {report_footer_items?.map((item: any, index: number) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center"
                >
                  <h2 className="text-[16px] font-bold">
                    ............................
                  </h2>
                  <h2 className="font-bold text-[14px] mt-1">
                    {language ? item?.name : item?.name_nepali}
                  </h2>
                  <h2 className="font-normal text-[12px] mt-0.5">
                    {language ? item?.designation : item?.designation_nepali}
                  </h2>
                </div>
              ))} */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PrintSingleVoucherView;